import { useRichTextParameters } from '@nucleus/web-theme';
import { useCallback } from 'react';

export const useLocalization = (): ((key: string, fallback: string) => string) => {
  const params = useRichTextParameters();

  return useCallback((key: string, fallback: string): string => params[`language:${key}`] ?? fallback, []);
};

